import {alias, createModelSchema, list, reference} from "serializr";
import {BaseObject} from "@/common/BaseObject";
import {Schema} from "@/common/Schema";
import {JobModel} from "../worker/jobs/JobModel";
import {RedactorUtils} from "@/modules/redactor/core/RedactorUtils";
import {ItemKey} from "@/modules/redactor/models/item/core/ItemKey";


export class ItemRecipe extends BaseObject {

    static schema() {
        return reference("uid", (uid, cb) => {
            return cb(null, RedactorUtils.getRecipe(uid));
        });
    }

    constructor() {
        super();

        this._key = null;
        this._name = null;
        this._items = null;

        this._order = 0;
        this._job = null;
    }

    get key() {
        return this._key;
    }

    set key(value) {
        this._key = value;
    }

    get name() {
        return this._name;
    }

    set name(value) {
        this._name = value;
    }

    get items() {
        return this._items;
    }

    set items(value) {
        this._items = value;
    }

    get order() {
        return this._order;
    }

    set order(value) {
        this._order = value;
    }

    get job() {
        return this._job;
    }

    set job(value) {
        this._job = value;
    }

    valid() {

        if(!this.items || this.items.length === 0){
            return false;
        }

        if (this.items && this.items.some(v => !v || !v.valid() || v.empty())) {
            return false;
        }

        if (!Number.isInteger(this.order) || this.order < 0) {
            return false;
        }

        if (!this.job || !this.job.valid()) {
            return false;
        }

        return true;
    }

    copy() {
        return super.copy();
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new ItemRecipe());
        } else if (target instanceof ItemRecipe) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(ItemRecipe, {
    _key: alias("key", Schema.primitive()),
    _name: alias("name", Schema.primitive()),
    _items: alias("items", list(ItemKey.schema())),

    _order: alias("order", Schema.primitive()),
    _job: alias("job", JobModel.schema())
});